module.exports = __webpack_public_path__ + "img/Frame-64.e5c87fea.svg";